import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

const ConfirmPopup = new Popup({
	title: function() {
		return this.get("title") || getLocaleString("confirmtitle");
	},
	distinct: true,
	render: function() {
		const confirm = () => {
			this.get("onconfirm")?.();
			_ui.closePopupOf(this);
		}
		return (
			<div className="popup-confirm">
				<p>{this.get("message")}</p>
				
				<br />
				
				<div className="confirm-buttons">
					<button onClick={confirm}>
						{getLocaleString("yes")}
					</button>
					<button onClick={() => _ui.closePopupOf(this)}>
						{getLocaleString("no")}
					</button>
				</div>
			</div>
		)
	}
});

export default ConfirmPopup;